import { Box, Grid } from "@mui/joy";

import { TextField, Textarea, Autocomplete } from "../../../../../shared";
import { SUPPLIER_TYPE_OPTIONS } from '../../../../../interfaces';


interface SupplierConfigurationProps {
    typeOptions?: { label: string; value: string }[];
}

export default function SupplierConfiguration({ typeOptions = SUPPLIER_TYPE_OPTIONS }: SupplierConfigurationProps) {
    return (
        <Box flex={1}>
            <Box mt={2} display={"flex"} flexDirection={"column"} gap={2}>
                <Grid container spacing={2}>
                    <Grid xs={6}>
                        <TextField
                            name={"Name"}
                            label={"Supplier Name"}
                            helperText={"Enter the legal or brand name of the supplier"}
                            placeholder={"e.g., ABC Roofing Supplies"}
                        />
                    </Grid>
                    <Grid xs={6}>
                        <Autocomplete
                            name={"Type"}
                            label={"Supplier Type"}
                            helperText={"Select if this supplier provides materials, labor, or both"}
                            placeholder={"Select type"}
                            options={typeOptions}
                        />
                    </Grid>
                </Grid>
                <Textarea
                    name={"Description"}
                    label={"Description"}
                    helperText={"Briefly describe what this supplier provides"}
                    placeholder={"e.g., Leading supplier of roofing materials and accessories"}
                    minRows={3}
                />
                <Grid container spacing={2}>
                    <Grid xs={6}>
                        <TextField
                            name={"Email"}
                            label={"Contact Email"}
                            helperText={"Primary email for communication"}
                            placeholder={"e.g., contact@supplier.com"}
                            type={"email"}
                        />
                    </Grid>
                    <Grid xs={6}>
                        <TextField
                            name={"PhoneNumber"}
                            label={"Phone Number"}
                            helperText={"Contact phone number"}
                            placeholder={"e.g., +1 (555) 123-4567"}
                            type={"tel"}
                        />
                    </Grid>
                </Grid>
                <Textarea
                    name={"Address"}
                    label={"Address"}
                    helperText={"Primary business address"}
                    placeholder={"e.g., 123 Main Street, Suite 100"}
                    minRows={2}
                />
                <Grid container spacing={2}>
                    <Grid xs={6}>
                        <TextField
                            name={"City"}
                            label={"City"}
                            helperText={"City where the supplier is located"}
                            placeholder={"e.g., Denver"}
                        />
                    </Grid>
                    <Grid xs={6}>
                        <TextField
                            name={"Country"}
                            label={"Country"}
                            helperText={"Country of operation"}
                            placeholder={"e.g., United States"}
                        />
                    </Grid>
                </Grid>
                <TextField
                    name={"Website"}
                    label={"Website"}
                    helperText={"Optional company website URL"}
                    placeholder={"e.g., https://www.supplier.com"}
                />
            </Box>
        </Box>
    );
}
